import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ChevronRightFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ChevronRightFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M11.295 5h-3.71l5.11 7-5.11 7h3.71l5.12-7-5.12-7Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ChevronRightFilled;